<template>
  <div class="page page__list">
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.sp_name}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-if="item.sp_caid">{{item.sp_cacode}}&nbsp;{{item.sp_caname}}</p>
          <p v-else>请设置</p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
  </div>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/finance/scmparameter/list",
      params: {
        number: 1,
        size: 100
      }
    };
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "FinanceBizCategoryEdit",
        params: {
          initData: Object.assign({}, item)
        }
      });
    }
  }
};
</script>